import React from 'react';
import { mockData } from '../mock';
import { Mail, Facebook, Instagram } from 'lucide-react';

const ContactCollaboration = () => {
  return (
    <section id="contact" className="bg-gray-50 py-20 border-t border-gray-200">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-gray-800 mb-6">
            Work With Rrammy
          </h2>
          <p className="text-gray-600 font-light text-lg max-w-3xl mx-auto">
            Interested in collaborating on your next commercial, brand film, or narrative project?
            <br />Let's bring your vision to life through cinematic storytelling.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {/* Primary Email */}
          <a
            href={`mailto:${mockData.director.email}`}
            className="group bg-white border border-gray-200 hover:border-gray-400 p-8 transition-all duration-300 hover:shadow-lg"
          >
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="w-12 h-12 flex items-center justify-center bg-gray-100 group-hover:bg-gray-800 transition-colors duration-300">
                <Mail className="text-gray-700 group-hover:text-white transition-colors" size={20} />
              </div>
              <div>
                <div className="text-xs uppercase tracking-wider text-gray-500 mb-2">Primary Email</div>
                <div className="text-gray-800 font-light text-sm group-hover:text-gray-600 transition-colors">
                  {mockData.director.email}
                </div>
              </div>
            </div>
          </a>

          {/* Secondary Email */}
          <a
            href={`mailto:${mockData.director.emailSecondary}`}
            className="group bg-white border border-gray-200 hover:border-gray-400 p-8 transition-all duration-300 hover:shadow-lg"
          >
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="w-12 h-12 flex items-center justify-center bg-gray-100 group-hover:bg-gray-800 transition-colors duration-300">
                <Mail className="text-gray-700 group-hover:text-white transition-colors" size={20} />
              </div>
              <div>
                <div className="text-xs uppercase tracking-wider text-gray-500 mb-2">Alternate Email</div>
                <div className="text-gray-800 font-light text-sm group-hover:text-gray-600 transition-colors">
                  {mockData.director.emailSecondary}
                </div>
              </div>
            </div>
          </a>

          {/* Facebook */}
          <a
            href={mockData.director.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white border border-gray-200 hover:border-gray-400 p-8 transition-all duration-300 hover:shadow-lg"
          >
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="w-12 h-12 flex items-center justify-center bg-gray-100 group-hover:bg-gray-800 transition-colors duration-300">
                <Facebook className="text-gray-700 group-hover:text-white transition-colors" size={20} />
              </div>
              <div>
                <div className="text-xs uppercase tracking-wider text-gray-500 mb-2">Facebook</div>
                <div className="text-gray-800 font-light text-sm group-hover:text-gray-600 transition-colors">
                  /nomadrammy
                </div>
              </div>
            </div>
          </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/theexpressofilms"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white border border-gray-200 hover:border-gray-400 p-8 transition-all duration-300 hover:shadow-lg"
          >
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="w-12 h-12 flex items-center justify-center bg-gray-100 group-hover:bg-gray-800 transition-colors duration-300">
                <Instagram className="text-gray-700 group-hover:text-white transition-colors" size={20} />
              </div>
              <div>
                <div className="text-xs uppercase tracking-wider text-gray-500 mb-2">Instagram</div>
                <div className="text-gray-800 font-light text-sm group-hover:text-gray-600 transition-colors">
                  @theexpressofilms
                </div>
              </div>
            </div>
          </a>
        </div>

        {/* Additional Info */}
        <div className="text-center mt-12">
          <p className="text-gray-500 font-light text-sm">
            Based in Mumbai, India • Available for projects worldwide
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactCollaboration;